import { render, staticRenderFns } from "./SettlementRules.vue?vue&type=template&id=6e0fe98d&scoped=true"
import script from "./SettlementRules.vue?vue&type=script&lang=js"
export * from "./SettlementRules.vue?vue&type=script&lang=js"
import style0 from "./SettlementRules.vue?vue&type=style&index=0&id=6e0fe98d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0fe98d",
  null
  
)

export default component.exports